import { render } from "./TopBarGA.vue?vue&type=template&id=4fd300e3&scoped=true"
import script from "./TopBarGA.vue?vue&type=script&lang=js"
export * from "./TopBarGA.vue?vue&type=script&lang=js"

import "./TopBarGA.vue?vue&type=style&index=0&id=4fd300e3&scoped=true&lang=css"

import exportComponent from "/home/nathan/Documentos/Creditall/Desenvolvimento/projetos/creditall/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fd300e3"]])

export default __exports__